import * as React from "react";
import Headroom from "react-headroom";
import { Link } from "react-router-dom";
import { Navigation } from "./navigation";
import { MemberNavigation } from "./member-navigation";

export interface HeaderProps {
  enableNavigation?: boolean;
}

export const Header = ({ enableNavigation = true }: HeaderProps) => (
  <header className="header" role="banner">
    <Headroom>
      <div className="header-secondary">
        <div className="header-secondary-inner || constrain-width large">
          <MemberNavigation />
        </div>
      </div>
      <div className="header-inner || constrain-width large">
        <Link to="/" className="header-logo">
          Rangitāne
        </Link>
        <h1 className="header-title">
          <Link className="header-title-link" to="/" data-testid="header-title">
            Rangitāne
          </Link>
        </h1>
        {enableNavigation && <Navigation />}
      </div>
    </Headroom>
  </header>
);
